import React from 'react'
import PropTypes from 'prop-types'

import Card from '../../../elements/Card'
import Heading from '../../../typography/Heading'

import PlacementItem from './PlacementItem'
import SkeletonPlacementCard from './SkeletonPlacementCard'

import styles from './styles'

const PlacementCard = ({ loading, header, theme = 'primary', currentMonth, currentQuarter, lastMonth }) =>
  loading ? (
    <SkeletonPlacementCard />
  ) : (
    <Card className={styles.card}>
      <Heading className={styles.header}>{header}</Heading>
      <ul className={styles.body}>
        <PlacementItem className={styles.quarter} heading="This quarter" count={currentQuarter} isCurrent theme={theme} />
        <PlacementItem className={styles.currentMonth} heading="This month" count={currentMonth} />
        <PlacementItem className={styles.lastMonth} heading="Last month" count={lastMonth} />
      </ul>
    </Card>
  )

PlacementCard.propTypes = {
  loading: PropTypes.bool.isRequired,
  header: PropTypes.string.isRequired,
  currentMonth: PropTypes.number,
  currentQuarter: PropTypes.number,
  lastMonth: PropTypes.number,
  theme: PropTypes.oneOf(['', 'primary', 'secondary']),
}

export default PlacementCard
